import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-full-plus-icon',
  templateUrl: './circle-full-plus-icon.component.html'
})
export class CircleFullPlusIconComponent {
}
